<template>
  <div>
    <detail-field class="mt-3" v-if="event.url">
      <div slot="label">Webhook URL:</div>
      <div slot="value">{{ event.url }}</div>
    </detail-field>
    <detail-field class="mt-3" v-if="event.status_code">
      <div slot="label">Response status code:</div>
      <div slot="value">{{ event.status_code }}</div>
    </detail-field>
    <detail-field class="mt-3">
      <div slot="label">Response body:</div>
      <div v-if="event.response_body" slot="value">
        <pre><code>{{ event.response_body }}</code></pre>
      </div>
      <div v-else slot="value">empty</div>
    </detail-field>
    <detail-field class="mt-3" v-if="event.error_desc">
      <div slot="label">Error description:</div>
      <div slot="value">{{ event.error_desc }}</div>
    </detail-field>
    <detail-field class="mt-3" v-if="event.payload">
      <div slot="label">Webhook content:</div>
      <div slot="value">
        <pre><code>{{ event.payload }}</code></pre>
      </div>
    </detail-field>
  </div>
</template>

<script>
  import DetailField from '@/components/administration/common/Field'

  export default {
    components: {
      'detail-field': DetailField
    },

    props: {
      event: {
        type: Object,
        required: true
      }
    }
  }
</script>
